// src/tradePack/index.js  →  dist/tradePack.js  (global: TradePack)
//
// The weekly trade meeting, on screen, as slides (v132.41).
//
// Matt: "every week i have to pull together this deck. Most of the info is
// on shift, but it takes me forever." The deck he sent was 35 slides and
// 152 pasted screenshots.
//
// This draws the Shift half as real 16:9 slides he can present from, or
// print to PDF. It is not a PowerPoint file: he chose the page over the
// file, so the pack can never be out of date and there is nothing to email
// around.
//
// THE PRINT RULES MATTER AS MUCH AS THE SCREEN. A slide that looks right in
// a browser and then splits across two sheets is worse than a screenshot,
// so each slide is a fixed-ratio block with page-break-inside: avoid and
// the page is landscape.

function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function root() { return document.getElementById('tradePackRoot'); }

var _data = null;
var _week = '';
var _busy = false;
// v136.53: the period for sales, add-ons and customer feedback (week | mtd | ytd | custom)
var _period = 'week';
var _from = '';
var _to = '';
var PERIODS = [['week', 'Week'], ['mtd', 'Month to date'], ['ytd', 'Year to date'], ['custom', 'Custom']];

// v136 dark mode: the SLIDES stay light in both themes, on purpose. A slide is what prints ("what is on screen is
// what prints"), so it keeps its white page, dark ink and RAG pills; only the bar above them (the buttons, the
// week picker, the hint) and the messages outside a slide follow the theme.
var RAG_BG = { green: '#e8f6ee', amber: '#fff7e6', red: '#fdecec', none: '#f3f4f6' };
var RAG_INK = { green: '#0b6b34', amber: '#92400e', red: '#991b1b', none: '#6b7280' };

function ensureStyles() {
  if (document.getElementById('tradePackStyles')) return;
  var st = document.createElement('style');
  st.id = 'tradePackStyles';
  st.textContent = [
    '.tp-bar{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-bottom:14px}',
    '.tp-btn{font-family:inherit;font-size:12.5px;font-weight:700;padding:6px 12px;border-radius:8px;border:1px solid var(--border-strong);background:var(--card);color:var(--adm-comms-ink);cursor:pointer}',
    '.tp-btn.go{background:#009E3D;color:#fff;border-color:#009E3D}',
    // A slide, not a card. 16:9, fixed, so what is on screen is what prints.
    '.tp-slide{position:relative;width:100%;max-width:1060px;aspect-ratio:16/9;margin:0 auto 18px;background:#fff;border:1px solid #e5e7eb;border-radius:14px;padding:26px 30px;box-sizing:border-box;overflow:hidden;display:flex;flex-direction:column}',
    '.tp-slide h3{margin:0 0 2px;font-size:23px;line-height:1.2;color:#111827}',
    '.tp-sub{font-size:12.5px;color:#6b7280;margin-bottom:12px}',
    '.tp-num{position:absolute;right:18px;bottom:12px;font-size:11px;color:#9ca3af}',
    '.tp-table{width:100%;border-collapse:collapse;font-size:13.5px}',
    '.tp-table th{text-align:start;font-size:11px;text-transform:uppercase;letter-spacing:.4px;color:#6b7280;border-bottom:1px solid #e5e7eb;padding:4px 8px 4px 0;font-weight:700}',
    '.tp-table td{padding:4px 8px 4px 0;border-bottom:1px solid #f3f4f6}',
    '.tp-table td.n,.tp-table th.n{text-align:end;font-variant-numeric:tabular-nums}',
    '.tp-note{margin-top:auto;padding-top:8px;font-size:11.5px;color:#92400e}',
    '.tp-empty{color:#9ca3af;font-size:14px;padding:20px 0}',
    '.tp-pill{display:inline-block;min-width:44px;text-align:center;border-radius:6px;padding:1px 6px;font-weight:700;font-size:12.5px}',
    // v136.62: the total row (sales slides). Bold, ruled off, coloured by the same rule as the stores.
    '.tp-table tfoot td{font-weight:800;border-top:1.5px solid currentColor;border-bottom:none;padding-top:6px}',
    '.tp-lfl{font-size:11.5px;opacity:.65;margin-top:4px}',
    // Print: landscape, one slide per sheet, nothing else on the page.
    // v132.80 (reported 28 Sep 2026: "the download for the weekly trade meeting
    // didnt work. it showed blank"): the old rules HID everything with
    // visibility and PINNED the pack to the top with position:absolute. Chrome
    // prints that, but WebKit (Safari on a Mac, any browser on an iPad or
    // iPhone) keeps the hidden content's space and will not split a pinned
    // element across pages, so it printed blank sheets. Now nothing else is
    // DISPLAYED at all, and the pack prints in normal flow in every browser.
    '@media print{',
    '  @page{size:A4 landscape;margin:8mm}',
    '  body > *:not(#adminApp){display:none !important}',
    '  #adminApp{display:block !important;min-height:0 !important}',
    '  #adminApp > *:not(#page-tradepack){display:none !important}',
    '  #page-tradepack{display:block !important;padding:0 !important;margin:0 !important;max-width:none !important}',
    '  #tradePackRoot{padding:0 !important}',
    '  .tp-bar,.tp-hint{display:none !important}',
    '  .tp-slide,.tp-pill{-webkit-print-color-adjust:exact;print-color-adjust:exact}',
    '  .tp-slide{page-break-inside:avoid;break-inside:avoid;page-break-after:always;border:none;border-radius:0;margin:0;max-width:none}',
    '}',
  ].join('\n');
  document.head.appendChild(st);
}

// Monday of the current week, so the default is the week being discussed.
// v132.81 (reported 28 Sep 2026: "all the add ons were blank"): the pack
// opened on the week CONTAINING today, which on a Monday has nothing uploaded
// yet. The meeting reviews the week just gone, so that is the default now,
// on the Dubai calendar (the UTC date is still Sunday until 04:00 Dubai).
function lastMonday() {
  var d = new Date(Date.now() + 4 * 3600 * 1000);
  var dow = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - dow - 7);
  return d.toISOString().slice(0, 10);
}

function cell(col, row) {
  var v = row[col.key];
  if (v == null || v === '') return '<td class="' + (col.numeric ? 'n' : '') + '" style="color:#9ca3af">-</td>';
  var text = col.numeric && typeof v === 'number' ? v.toLocaleString() : String(v);
  if (col.suffix) text += col.suffix;
  // The RAG colour rides the row, not the cell, and only where the row has
  // an opinion. A colour on every number is a colour nobody reads.
  if (col.key === 'store' && row.rag && row.rag !== 'none') {
    return '<td><span class="tp-pill" style="background:' + RAG_BG[row.rag] + ';color:' + RAG_INK[row.rag] + '">' + esc(text) + '</span></td>';
  }
  return '<td class="' + (col.numeric ? 'n' : '') + '">' + esc(text) + '</td>';
}

function slideHtml(s) {
  var cols = s.columns || [];
  var rows = s.rows || [];
  var body = rows.length
    ? '<table class="tp-table"><thead><tr>' +
        cols.map(function (c) { return '<th class="' + (c.numeric ? 'n' : '') + '">' + esc(c.label) + '</th>'; }).join('') +
      '</tr></thead><tbody translate="no">' +
        rows.slice(0, 14).map(function (r) {
          return '<tr>' + cols.map(function (c) { return cell(c, r); }).join('') + '</tr>';
        }).join('') +
      '</tbody>' +
      (s.total ? '<tfoot><tr>' + cols.map(function (c) { return cell(c, s.total); }).join('') + '</tr></tfoot>' : '') +
      '</table>' +
      (s.total && s.total.note ? '<div class="tp-lfl">' + esc(s.total.note) + '.</div>' : '') +
      (rows.length > 14 ? '<div style="font-size:11.5px;color:#6b7280;margin-top:4px">' + (rows.length - 14) + ' more, in the app.</div>' : '')
    : '<div class="tp-empty">' + (s.range_label && s.range_label.indexOf('Week commencing') !== 0 ? 'Nothing to show for this period.' : 'Nothing to show for this week.') + '</div>';
  return '<section class="tp-slide">' +
    '<h3>' + esc(s.title) + '</h3>' +
    '<div class="tp-sub">' + esc(s.range_label || (_week ? 'Week commencing ' + _week : '')) + '</div>' +
    body +
    (s.note ? '<div class="tp-note">' + esc(s.note) + '</div>' : '') +
    '<div class="tp-num">' + s.n + '</div>' +
  '</section>';
}

function dateInput(id, value, label) {
  return '<input type="date" id="' + id + '" value="' + esc(value) + '" aria-label="' + esc(label) + '" style="font-family:inherit;font-size:12.5px;padding:5px 8px;border:1px solid var(--border-strong);border-radius:8px">';
}
function bar() {
  var periods = PERIODS.map(function (p) {
    var on = p[0] === _period;
    return '<button class="tp-btn' + (on ? ' go' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" onclick="TradePack.setPeriod(\'' + p[0] + '\')">' + esc(p[1]) + '</button>';
  }).join('');
  var dates = _period === 'custom'
    ? '<span style="font-size:12.5px;color:var(--sub)">From</span>' + dateInput('tpFrom', _from, 'From') + '<span style="font-size:12.5px;color:var(--sub)">To</span>' + dateInput('tpTo', _to, 'To')
    : dateInput('tpWeek', _week, _period === 'week' ? 'Week' : 'Up to');
  var hint = _period === 'week'
    ? 'It opens on last week. Pick any day to change it: it uses that whole week, Monday to Sunday.'
    : 'Sales, add-ons and customer feedback cover the period. The other slides only exist by the week, so they show the last full week in it.';
  return '<div class="tp-bar">' +
    '<b style="font-size:15px">Trade pack</b>' +
    '<div style="display:inline-flex;gap:4px;flex-wrap:wrap">' + periods + '</div>' +
    dates +
    '<button class="tp-btn go" onclick="TradePack.load()"' + (_busy ? ' disabled' : '') + '>' + (_busy ? 'Building...' : 'Build the pack') + '</button>' +
    '<button class="tp-btn" onclick="TradePack.printPack()">Print or save as PDF</button>' +
    '<span class="tp-hint" style="font-size:11.5px;color:var(--sub)">' + esc(hint) + '</span>' +
  '</div>';
}
// v136.53: pick the period. Month and year to date run to the day in the date box (yesterday when empty).
function setPeriod(p) {
  if (!PERIODS.some(function (x) { return x[0] === p; })) return;
  readInputs();
  _period = p;
  if (p !== 'week' && _week === lastMonday()) _week = '';
  if (p === 'week' && !_week) _week = lastMonday();
  paint();
}
function readInputs() {
  var w = document.getElementById('tpWeek'); if (w) _week = w.value || '';
  var f = document.getElementById('tpFrom'); if (f) _from = f.value || '';
  var t = document.getElementById('tpTo'); if (t) _to = t.value || '';
}

function paint() {
  ensureStyles();
  var el = root(); if (!el) return;
  if (!_data) {
    el.innerHTML = bar() + '<div class="tp-empty" style="text-align:center;color:var(--adm-comms-faint)">' +
      (_busy ? 'Building the pack...' : 'Pick a week and build the pack.') + '</div>';
    return;
  }
  if (_data.error) {
    el.innerHTML = bar() + '<div class="tp-empty" style="color:var(--adm-comms-bad-text)">' + esc(_data.error) + '</div>';
    return;
  }
  var slides = (_data.slides || []).map(slideHtml).join('');
  var missing = (_data.not_included || []).map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
  var cover = '<section class="tp-slide" style="justify-content:center">' +
      '<h3 style="font-size:34px">Trade meeting</h3>' +
      '<div style="font-size:16px;color:#6b7280;margin-top:4px">' + esc((_data.period && _data.period.label) || ('Week commencing ' + _week)) +
        (_data.period && _data.period.kind !== 'week' ? '<div style="font-size:13px;margin-top:4px">' + esc('The weekly slides: Week commencing ' + ((_data.week && _data.week.week_start) || '')) + '</div>' : '') + '</div>' +
      '<div style="font-size:13px;color:#6b7280;margin-top:20px">' + (_data.area_managers || []).length + ' area manager(s), ' + (_data.slides || []).length + ' slides, built from Shift.</div>' +
      (missing ? '<div style="margin-top:18px;font-size:12px;color:#92400e"><b>Not in this pack:</b><ul style="margin:4px 0 0;padding-inline-start:18px">' + missing + '</ul></div>' : '') +
    '</section>';
  el.innerHTML = bar() + cover + slides;
}

// v132.47 — the admin app has NO global `api()`. The one in db.js is declared
// inside a closure and never exported, so calling a bare `api(...)` from a
// bundle throws ReferenceError at runtime, which the catch below reported as
// "check your connection" - a wrong and very misleading diagnosis.
//
// Every other admin bundle (commsReport, trainingAdmin) carries its own local
// helper built on DB.workerUrl() + DB.getToken(). A RELATIVE /api/ path is
// also wrong: it hits Netlify, not the Worker, and 404s. Follow the house
// pattern.
async function apiGet(path) {
  var token = (typeof DB !== 'undefined' && DB.getToken) ? DB.getToken() : null;
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  var headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = 'Bearer ' + token;
  var res = await fetch(base + path, { method: 'GET', headers: headers, cache: 'no-store' });
  var payload = await res.json().catch(function () { return {}; });
  if (!res.ok || payload.ok === false) {
    throw new Error((payload && (payload.error || payload.reason)) || ('HTTP ' + res.status));
  }
  return payload;
}

async function load() {
  readInputs();
  var q;
  if (_period === 'week') {
    if (!_week) _week = lastMonday();
    q = 'week_start=' + encodeURIComponent(_week);
  } else if (_period === 'custom') {
    if (!_from || !_to) { if (typeof showToast === 'function') showToast('Pick a start date and an end date', 'error'); return; }
    q = 'period=custom&from=' + encodeURIComponent(_from) + '&to=' + encodeURIComponent(_to);
  } else {
    q = 'period=' + _period + (_week ? '&week_start=' + encodeURIComponent(_week) : '');
  }
  _busy = true; _data = null; paint();
  try {
    var d = await apiGet('/api/admin/trade-pack?' + q);
    _busy = false;
    _data = d;
    // v136.53: only the Week box snaps to the Monday; for month or year to date the box is the "up to" day
    if (_period === 'week') _week = (d.week && d.week.week_start) || _week;
    paint();
  } catch (e) {
    // Say what actually went wrong. "Check your connection" sent Matt looking
    // at his wifi when the real fault was a missing function.
    _busy = false;
    _data = { error: 'Could not build the pack: ' + ((e && e.message) || 'unknown error') };
    paint();
  }
}

function render() {
  if (!_week) _week = lastMonday();
  paint();
}

// v132.80: printing an unbuilt pack gave a sheet with nothing on it, and the
// home-screen app on an iPhone or iPad cannot print at all. Say so, instead of
// handing the person a blank page.
function isHomeScreenApp() {
  try {
    return !!(window.navigator && window.navigator.standalone) ||
      !!(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
  } catch (e) { return false; }
}
function printPack() {
  var slides = _data && !_data.error ? (_data.slides || []) : [];
  if (!slides.length) {
    if (typeof showToast === 'function') showToast('Build the pack first, then print it', 'error');
    return;
  }
  if (isHomeScreenApp() && /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent || '') && 'ontouchend' in document) {
    if (typeof showToast === 'function') showToast('The Shift app on an iPhone or iPad cannot print. Open Shift in Safari or on a computer to print or save the pack.', 'error');
    return;
  }
  try { window.print(); }
  catch (e) { if (typeof showToast === 'function') showToast('This browser could not open printing. Try Chrome or Edge on a computer.', 'error'); }
}

window.TradePack = { render: render, load: load, printPack: printPack };
window.TradePack.setPeriod = setPeriod;   // v136.53: the period buttons

export { render, load, printPack };
export { setPeriod };   // v136.53
